var map = {
	"./product-compliance/issue-icon-active.svg": "c8e5",
	"./product-compliance/issue-icon-dark.svg": "6c36",
	"./product-compliance/issue-icon.svg": "9c55",
	"./product-compliance/operation-icon-active.svg": "c947",
	"./product-compliance/operation-icon-dark.svg": "31fa",
	"./product-compliance/operation-icon.svg": "2629",
	"./product-compliance/process-icon-active.svg": "062d",
	"./product-compliance/process-icon-dark.svg": "1e99",
	"./product-compliance/process-icon.svg": "b67d",
	"./product-compliance/sire-icon-active.svg": "65ff",
	"./product-compliance/sire-icon-dark.svg": "6082",
	"./product-compliance/sire-icon.svg": "7d20",
	"./product-compliance/task-manager-icon-active.svg": "1d74",
	"./product-compliance/task-manager-icon-dark.svg": "5150",
	"./product-compliance/task-manager-icon.svg": "b46b",
	"./product-documents/customer-icon-active.svg": "a305",
	"./product-documents/customer-icon-dark.svg": "c5e0",
	"./product-documents/customer-icon.svg": "3478",
	"./product-documents/dashboard-icon-active.svg": "3f67",
	"./product-documents/dashboard-icon-dark.svg": "f131",
	"./product-documents/dashboard-icon.svg": "c7fd",
	"./product-documents/document-icon-active.svg": "38d5",
	"./product-documents/document-icon-dark.svg": "01d9",
	"./product-documents/document-icon.svg": "2009",
	"./product-documents/fl-icon-active.svg": "be10",
	"./product-documents/fl-icon-dark.svg": "84f0",
	"./product-documents/fl-icon.svg": "2b74",
	"./product-documents/folios-icon-active.svg": "4af1",
	"./product-documents/folios-icon-dark.svg": "8bf2",
	"./product-documents/folios-icon.svg": "2860",
	"./product-documents/home-icon-active.svg": "14eb",
	"./product-documents/home-icon-dark.svg": "34dd",
	"./product-documents/home-icon.svg": "f34c",
	"./product-documents/portal-icon-active.svg": "3c3e",
	"./product-documents/portal-icon-dark.svg": "9026",
	"./product-documents/portal-icon.svg": "34ea",
	"./product-documents/purchase-icon-active.svg": "cd8b",
	"./product-documents/purchase-icon-dark.svg": "1e9d",
	"./product-documents/purchase-icon.svg": "f555",
	"./product-documents/report-icon-active.svg": "ef4e",
	"./product-documents/report-icon-dark.svg": "ff1b",
	"./product-documents/report-icon.svg": "4f75",
	"./product-folios/branch-icon-active.svg": "9d1d",
	"./product-folios/branch-icon-dark.svg": "9b8c",
	"./product-folios/branch-icon.svg": "21d8",
	"./product-folios/folios-icon-active.svg": "cfeb",
	"./product-folios/folios-icon-dark.svg": "4289",
	"./product-folios/folios-icon.svg": "f93b",
	"./product-folios/groups-icon-active.svg": "f9f2",
	"./product-folios/groups-icon-dark.svg": "5e03",
	"./product-folios/groups-icon.svg": "f64a",
	"./product-folios/logs-icon-active.svg": "f893",
	"./product-folios/logs-icon-dark.svg": "195d",
	"./product-folios/logs-icon.svg": "0dc5",
	"./product-folios/monitor-icon-active.svg": "20c5",
	"./product-folios/monitor-icon-dark.svg": "4245",
	"./product-folios/monitor-icon.svg": "05f7",
	"./product-folios/pos-icon-active.svg": "eefd",
	"./product-folios/pos-icon-dark.svg": "8f4b",
	"./product-folios/pos-icon.svg": "3dc8",
	"./product-folios/rollout-icon-active.svg": "e3913",
	"./product-folios/rollout-icon-dark.svg": "d127",
	"./product-folios/rollout-icon.svg": "fd1f",
	"./product-holdings/audit-icon-active.svg": "6610",
	"./product-holdings/audit-icon-dark.svg": "0a01",
	"./product-holdings/audit-icon.svg": "ba92",
	"./product-holdings/certificates-icon-active.svg": "c73e",
	"./product-holdings/certificates-icon-dark.svg": "7efa",
	"./product-holdings/certificates-icon.svg": "d966",
	"./product-holdings/organizations-icon-active.svg": "e630",
	"./product-holdings/organizations-icon-dark.svg": "0cb6",
	"./product-holdings/organizations-icon.svg": "c0e7",
	"./product-holdings/orgunits-icon-active.svg": "ca0d",
	"./product-holdings/orgunits-icon-dark.svg": "12e0",
	"./product-holdings/orgunits-icon.svg": "2c7e",
	"./product-holdings/users-icon-active.svg": "081b",
	"./product-holdings/users-icon-dark.svg": "c28a",
	"./product-holdings/users-icon.svg": "8eea",
	"./product-insight/insight-icon.svg": "9237",
	"./product-outbound/home-icon-active.svg": "6c94",
	"./product-outbound/home-icon-dark.svg": "c556",
	"./product-outbound/home-icon.svg": "a71c",
	"./product-outbound/portal-icon-active.svg": "c2e6",
	"./product-outbound/portal-icon-dark.svg": "39d8",
	"./product-outbound/portal-icon.svg": "ac2a",
	"./product-outbound/report-icon-active.svg": "6c2e",
	"./product-outbound/report-icon-dark.svg": "8f75",
	"./product-outbound/report-icon.svg": "ce30",
	"./product-outbound/template-icon-active.svg": "ea83",
	"./product-outbound/template-icon-dark.svg": "d4a9",
	"./product-outbound/template-icon.svg": "f033",
	"./product-outbound/tracker-icon-active.svg": "ae34",
	"./product-outbound/tracker-icon-dark.svg": "b804",
	"./product-outbound/tracker-icon.svg": "7703",
	"./product-pos/branch-icon-active.svg": "b306",
	"./product-pos/branch-icon-dark.svg": "251e",
	"./product-pos/branch-icon.svg": "4347",
	"./product-pos/groups-icon-active.svg": "3d5a",
	"./product-pos/groups-icon-dark.svg": "9242",
	"./product-pos/groups-icon.svg": "11c9",
	"./product-pos/logs-icon-active.svg": "1b6a",
	"./product-pos/logs-icon-dark.svg": "ab02",
	"./product-pos/logs-icon.svg": "eb20",
	"./product-pos/monitor-icon-active.svg": "0053",
	"./product-pos/monitor-icon-dark.svg": "14df",
	"./product-pos/monitor-icon.svg": "c933",
	"./product-pos/pos-icon-active.svg": "e8ba",
	"./product-pos/pos-icon-dark.svg": "002d",
	"./product-pos/pos-icon.svg": "1ebd",
	"./product-pos/report-icon-active.svg": "45bd",
	"./product-pos/report-icon-dark.svg": "8cfd",
	"./product-pos/report-icon.svg": "33d5",
	"./product-pos/rollout-icon-active.svg": "0fd1",
	"./product-pos/rollout-icon-dark.svg": "3359",
	"./product-pos/rollout-icon.svg": "99a4",
	"./product-purchase/automation-icon-active.svg": "b762",
	"./product-purchase/automation-icon-dark.svg": "2eec",
	"./product-purchase/automation-icon.svg": "fc3f",
	"./product-purchase/claim-icon-active.svg": "bb90",
	"./product-purchase/claim-icon-dark.svg": "91c6",
	"./product-purchase/claim-icon.svg": "05c1",
	"./product-purchase/customer-icon-active.svg": "5e2d",
	"./product-purchase/customer-icon-dark.svg": "516f",
	"./product-purchase/customer-icon.svg": "9fbf",
	"./product-purchase/dashboard-icon-active.svg": "1093",
	"./product-purchase/dashboard-icon-dark.svg": "27f4",
	"./product-purchase/dashboard-icon.svg": "3318",
	"./product-purchase/fl-icon-active.svg": "3ec8",
	"./product-purchase/fl-icon-dark.svg": "0094",
	"./product-purchase/fl-icon.svg": "cdc2",
	"./product-purchase/folios-icon-active.svg": "46c2",
	"./product-purchase/folios-icon-dark.svg": "1045",
	"./product-purchase/folios-icon.svg": "ca07",
	"./product-purchase/home-icon-active.svg": "5519",
	"./product-purchase/home-icon-dark.svg": "3dd0",
	"./product-purchase/home-icon.svg": "7507",
	"./product-purchase/portal-icon-active.svg": "c67b",
	"./product-purchase/portal-icon-dark.svg": "25fd",
	"./product-purchase/portal-icon.svg": "1502",
	"./product-purchase/purchase-icon-active.svg": "2571",
	"./product-purchase/purchase-icon-dark.svg": "d932",
	"./product-purchase/purchase-icon.svg": "6458",
	"./product-purchase/report-icon-active.svg": "bc39",
	"./product-purchase/report-icon-dark.svg": "5647",
	"./product-purchase/report-icon.svg": "be58"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c394";